import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ConsumptionReporting = lazy(() =>
  import("@scenes/ConsumptionReporting/components/ConsumptionReporting").then((module) => ({
    default: module.ConsumptionReporting,
  }))
);

export const consumptionReportingNRO: NavigationRoutingObject = {
  section: "settings",
  Component: ConsumptionReporting,
  componentFeatureFlippers: ["consumption_reporting_nro_component"],
  heading: (t: I18nT<"dashboard-navigation">) => t("consumption-reporting-nro-heading", "Credit Usage"),
  getDeveloperNavigationAllowed: ({ featureOn }) =>
    featureOn("native_sms") ||
    featureOn("native_whatsapp") ||
    featureOn("clip_message_credit_dashboard_expansion_2024_03_05") ||
    featureOn("clip_message_credits_dashboard_fy25") ||
    featureOn("webhooks_message_credit_dashboard") ||
    featureOn("custom_ai_agents"),
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
